<template>
  <div>
    <el-dialog title="学历信息" :visible.sync="dialog" width="1100px">
      <div class="education">
        <el-form ref="ruleForm" :model="formData" label-width="80px">
          <div
              :id="`education${index+1}`"
              v-for="(education, index) in formData.educations"
              :key="index"
              style="margin-bottom: 10px; padding: 10px 0;"
          >
            <div style="display: flex;justify-content: space-between;padding-right: 66px">
              <div class="title-name">{{'学历'+indexToChinese(index)+'、'}}</div>
              <div><el-button @click="deleteContract(index)" type="danger" icon="el-icon-delete" circle size="mini"></el-button></div>
            </div>
            <el-row style="margin-bottom: 10px">
              <el-col :span="8">
                <el-form-item label="所在院校"
                              :prop="`educations.${index}.schoolName`"
                              :rules="[{ required: true, message: '请输入', trigger: 'change' }]">
                  <el-input style="width: 200px" v-model="education.schoolName" placeholder="请输入" show-word-limit />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="专业"
                              :prop="`educations.${index}.major`"
                              :rules="[{ required: true, message: '请输入', trigger: 'change' }]">
                  <el-input style="width: 200px" v-model="education.major" placeholder="请输入" show-word-limit />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item
                    label="毕业时间"
                    :prop="`educations.${index}.graduateTime`"
                    :rules="[{required: true, message: '请选择', trigger: 'change' }]">
                  <el-date-picker style="width: 200px"
                                  v-model="education.graduateTime"
                                  type="date"
                                  format="yyyy-MM-dd"
                                  value-format="yyyy-MM-dd"
                                  placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="类型"
                              :prop="`educations.${index}.isFullTime`"
                              :rules="[{ required: true, message: '请选择', trigger: 'change' }]">
                  <el-select v-model="education.isFullTime" placeholder="请选择" style="width: 200px">
                    <el-option label="全日制" :value="0"/>
                    <el-option label="非全日制" :value="1"/>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                    label="学历"
                    :prop="`educations.${index}.educationRankId`"
                    :rules="[{required: true, message: '请选择', trigger: 'change' }]">
                  <el-select v-model="education.educationRankId" placeholder="请选择" style="width: 200px">
                    <el-option
                        v-for="item in educationLevel"
                        :key="Number(item.dictValue)"
                        :label="item.dictLabel"
                        :value="Number(item.dictValue)">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div style="display:flex;justify-content: center;margin-top: 40px">
            <el-button type="danger" @click="addEducation">新增学历</el-button>
          </div>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialog = false">取 消</el-button>
        <el-button type="danger" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {getDictByKey} from "../../../../../api/contacts/dict";
import {updateContract,deleteContract} from "../../../../../api/contacts/user";
export default {
  name: "UpdateEducation",
  data() {
    return {
      dialog:false,
      formData: {
        workId:null,
        educations: []
      },
      userDetails:{},
      educationLevel:[],
    }
  },
  methods: {
    addEducation(){
      let item = {
        educationRank:[],
        signContractFirstParty:null,
        contractEndTime:"",
        contractStartTime:""
      }
      this.formData.educations.push(item);
    },
    deleteContract(index){
      let id = this.formData.educations[index].id;
      if (id && id!=null){
        deleteContract(id).then(val=>{
          if (val.status){
            this.$emit('success');
            this.$notify.success({message: "删除成功！", offset: 40});
            this.formData.educations.splice(index, 1);
          }else {
            this.$notify.error({message: "删除失败！", offset: 40});
          }
        });
      }else {
        this.formData.educations.splice(index, 1)
      }
    },
    confirm(){
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) {return false;}
        updateContract(this.formData).then(val=>{
          if (val.status){
            this.$emit('success');
            this.dialog = false;
            this.$notify.success({message: "更新成功！", offset: 40});
          }else {
            this.$notify.error({message: "更新失败！", offset: 40});
          }
        })
      });
    },
    openDialog(item){
      console.log(item)
      this.dialog = true;
      this.userDetails = item;
      this.formData.workId = this.userDetails.workId;
      this.formData.educations = JSON.parse(JSON.stringify(this.userDetails.educations));
    },
    indexToChinese(index) {
      let list = ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十"];
      return list[index] || `${index + 1}、`;
    },
  },
  created() {
    getDictByKey("educationRank").then(val=>{
      if (val.status){this.educationLevel = val.data;}
    })
  }
}
</script>

<style scoped>
.education{
  height: 400px;
  overflow:auto;
  margin-left: 30px;
}
.title-name{
  color: black;
  font-size: 15px;
  font-weight: 900;
  margin-bottom: 20px;
}
</style>